import { render, staticRenderFns } from "./DashboardOperationGroupNew.vue?vue&type=template&id=3287824e&scoped=true"
import script from "./DashboardOperationGroupNew.vue?vue&type=script&lang=js"
export * from "./DashboardOperationGroupNew.vue?vue&type=script&lang=js"
import style0 from "./DashboardOperationGroupNew.vue?vue&type=style&index=0&id=3287824e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3287824e",
  null
  
)

export default component.exports